<script setup>
import { istitutoPage } from '@/graphql/queries/istituto.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(istitutoPage, variables)

if (!data.value.paginaIstituto) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value?.paginaIstituto || {})
const seo = computed(() => page?.value?.seo || {})

useSeo(seo)
</script>

<template>
  <div class="istituto-page">
    <div class="p-top-xxl-2 row-400-25-default max-content">
      <LazyTitleDoubleColText :block="page.intro" type="custom-position" />
      <LazyTitleDoubleColText
        :block="page.sezioneDoppiaColonna1"
        type="custom-position"
      />
      <LazyImgText
        :block="page.sezioneImmagineTesto"
        :type="
          page.sezioneImmagineTesto.immagineADestra
            ? 'reverse in-detail-page'
            : 'default in-detail-page'
        "
        image-shape="capsule"
        class="no-row-rule"
      />
      <LazyTitleDoubleColText
        :block="page.sezioneDoppiaColonna2"
        type="custom-position"
      />
    </div>
    <div class="row-130-25 p-top-xxl-2 max">
      <LazyRecensioni :block="page.recensioni" />
    </div>
    <div class="p-top-xl-1">
      <div :style="{ backgroundColor: page.preFooter.coloreSfondo.hex }">
        <LazyTitleDoubleColText
          class="row-400-25-default max-content"
          :block="page.preFooter.contenuto"
          type="on-text"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IstitutoPage',
}
</script>
